import React from "react";
import { observer } from "mobx-react";
import { TerritoryUpdateStore } from "../../store";
import { TerritoryUpdateForm } from "./TerritoryUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type TerritoryUpdateProps = {
  territoryUpdateStore: TerritoryUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const TerritoryUpdate: React.FC<TerritoryUpdateProps> = observer(
  ({ territoryUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={territoryUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={territoryUpdateStore.savedButOutdated}
          onReload={() => territoryUpdateStore.reloadTerritory()}
          reloadDisabled={territoryUpdateStore.isProcessing}
        />
        <TerritoryUpdateForm
          territoryUpdateStore={territoryUpdateStore}
          name_esError={territoryUpdateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            territoryUpdateStore.setName_esValue(value);
          }}
          name_es={territoryUpdateStore.entityValues.name_es}
          name_enError={territoryUpdateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            territoryUpdateStore.setName_enValue(value);
          }}
          name_en={territoryUpdateStore.entityValues.name_en}
          name_ptError={territoryUpdateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            territoryUpdateStore.setName_ptValue(value);
          }}
          name_pt={territoryUpdateStore.entityValues.name_pt}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={territoryUpdateStore.saveDisabled}
          onSave={() => territoryUpdateStore.saveTerritory()}
          onCancel={() => territoryUpdateStore.cancelTerritory()}
        />
        <ErrorDialog
          open={territoryUpdateStore.errorDialogOpened}
          title={territoryUpdateStore.errorTitle}
          description={territoryUpdateStore.errorDescription}
          onClose={() => territoryUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={territoryUpdateStore.confirmDialogOpened}
          title={territoryUpdateStore.confirmDialogTitle}
          description={territoryUpdateStore.confirmDialogDescription}
          onConfirm={() => territoryUpdateStore.executeConfirmedAction()}
          onCancel={() => territoryUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
